import axios from "axios";
import { baseURL } from "config";

async function getChatResults(params: any) {
  const res = await axios.get(`${baseURL}/admin/chat-results`, { params });
  return res.data;
}

export default getChatResults;
